export default "__VITE_ASSET__B4KkF36C__"